




import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PopupAdd from './PopupAdd.vue';

@Component({ components: { AdminIframe, PopupAdd } })
export default class PopupAddContent extends Vue {
  private get remoteSrc() {
    const queryObject = {
      ...this.$route.query,
      serviceType: 'PRO',
    };

    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + this.$route.path + '?' + queryString;

    return src;
  }
}
